import SelectEffectPage from "./view";

export default function StartPage({ arApps, onStart }) {

    return <SelectEffectPage arApps={arApps} onStart={onStart} />
}